import React, { useEffect, useState, useRef } from 'react';
import aboutSection1 from '../../assets/images/about/about_section_1.png';
import QRDownloadPopup from '../common/QRDownloadPopup';
import { handleAppDownload } from '../../utils/mobileUtils';

function AboutSection1() {
  const [isVisible, setIsVisible] = useState(false);
  const [isQRPopupOpen, setIsQRPopupOpen] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        // 섹션이 화면에 보일 때만 애니메이션 적용
        if (entry.isIntersecting) {
          setIsVisible(true);
        } else {
          // 섹션이 화면에서 벗어났을 때
          setIsVisible(false);
        }
      },
      {
        threshold: 0.05, // 섹션이 20% 이상 보일 때 트리거
        rootMargin: '-20px' // 뷰포트 경계에서 50px 안쪽에서 트리거
      }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      const currentSection = sectionRef.current;
      if (currentSection) {
        observer.unobserve(currentSection);
      }
    };
  }, []);

  const onAppDownloadClick = () => {
    handleAppDownload(setIsQRPopupOpen);
  };

  return (
    <section ref={sectionRef} className="w-full min-h-[640px] md:h-[620px] flex justify-center bg-gradient-to-b md:bg-gradient-to-r from-[#C04EE9] to-[#FFF2FF] overflow-hidden relative pt-[60px] md:pt-[10px]">
      <div className="w-full flex flex-col md:flex-row items-center justify-between h-full md:h-[620px]">
        {/* 왼쪽 텍스트 */}
        <div
          className={`w-full md:w-1/2 flex flex-col justify-center items-center md:items-end px-4 md:pl-[80px] md:pr-[20px] space-y-[12px] md:space-y-[40px] transition-all duration-[1500ms] [transition-timing-function:cubic-bezier(0.4,0,0.2,1)] ${isVisible ? 'opacity-100' : 'opacity-0'} relative z-20`}>
          <div className="text-center md:text-left w-full md:w-auto">
            <h1 className="text-[40px] md:text-[54px] font-pretendard font-bold text-white leading-[130%]">
              컬러렌즈 쇼핑, <br />이제 더 선명하게 PONPISH
            </h1>
            <p className="text-[18px] md:text-[24px] text-white leading-[160%] pt-[16px]">
              컬러렌즈 트렌드가 시작되는 곳<br />내 취향대로 고르고, AR착용으로 미리보기
            </p>
            <div className="flex flex-col md:flex-row gap-4 justify-start pt-[32px] md:pt-[48px] px-12 md:px-0">
              <button onClick={onAppDownloadClick} className="bg-black text-white px-10 py-3 rounded-full font-semibold text-[16px] md:text-[20px] shadow-md hover:bg-gray-800 transition whitespace-nowrap cursor-pointer">
                App 다운로드 →
              </button>
              <a
                href="https://ponpish.co.kr/"
                target="_blank"
                rel="noopener"
                className="bg-black text-white px-10 py-3 rounded-full font-semibold text-[16px] md:text-[20px] shadow-md hover:bg-gray-800 transition whitespace-nowrap cursor-pointer inline-block text-center"
              >
                폰피쉬 쇼핑하기 →
              </a>
            </div>
          </div>
        </div>
        {/* 오른쪽 이미지 */}
        <div 
          className={`w-full md:w-1/2 flex justify-center md:justify-start transition-all duration-[2000ms] [transition-timing-function:cubic-bezier(0.4,0,0.2,1)] ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-[50px]'} relative md:absolute md:right-0 md:top-0 md:h-full z-10 mt-auto md:mt-0`}>
          <div className="w-full md:w-[700px] md:h-full">
            <img src={aboutSection1} alt="섹션1 이미지" className="w-full h-auto object-contain md:hidden" />
            <img src={aboutSection1} alt="섹션1 이미지" className="hidden md:block w-full h-full object-cover" />
          </div>
        </div>
      </div>

      {/* QR 다운로드 팝업 */}
      <QRDownloadPopup
        open={isQRPopupOpen}
        onClose={() => setIsQRPopupOpen(false)}
      />
    </section>
  );
}

export default AboutSection1; 